// extracted by mini-css-extract-plugin
export default {"backButton":"EXGrh","transparent":"jty19"};